import React from 'react';
import { Button, Flex, Text } from '@fluentui/react-northstar';

import MainLayout from './MainLayout';

import { ErrorLayoutProps } from './module/types';

const StatusLayout = ({
    image,
    heading,
    width = '400px',
    content,
    action,
    actionText,
    actionStyles,
    actionLoading = false,
    actionDisabled,
}: ErrorLayoutProps) => {
    return (
        <MainLayout width={width}>
            <Flex className="fs-unmask" column={true} hAlign="center">
                {image}
                <Text as="h2" weight="bold" align="center">
                    {heading}
                </Text>
                {content}
                {action && (
                    <Button
                        id="status-btn"
                        loading={actionLoading}
                        styles={actionStyles}
                        content={actionText}
                        onClick={action}
                        disabled={actionDisabled}
                        primary
                    />
                )}
            </Flex>
        </MainLayout>
    );
};

export default StatusLayout;
